__turbopack_context__.v({
  "container": "FAQ-module__rhnmfa__container",
  "faq": "FAQ-module__rhnmfa__faq",
  "faqAnswer": "FAQ-module__rhnmfa__faqAnswer",
  "faqAnswerInner": "FAQ-module__rhnmfa__faqAnswerInner",
  "faqChevron": "FAQ-module__rhnmfa__faqChevron",
  "faqHeader": "FAQ-module__rhnmfa__faqHeader",
  "faqOpen": "FAQ-module__rhnmfa__faqOpen",
  "faqText": "FAQ-module__rhnmfa__faqText",
  "faqTitle": "FAQ-module__rhnmfa__faqTitle",
  "faqs": "FAQ-module__rhnmfa__faqs",
});
